import { render } from "./quiz-v1.vue?vue&type=template&id=f80f4ce2&scoped=true"
import script from "./quiz-v1.vue?vue&type=script&lang=js"
export * from "./quiz-v1.vue?vue&type=script&lang=js"

import "./quiz-v1.vue?vue&type=style&index=0&id=f80f4ce2&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80f4ce2"]])

export default __exports__